import {
  Component,
  input,
  TemplateRef,
  AfterContentInit,
  ContentChildren,
  QueryList,
  ContentChild,
  Output,
  EventEmitter,
  effect,
  OnDestroy,
} from '@angular/core';

import { KanziTemplate } from '../../directives/kanzi-template/kanzi-template.directive';
import { CommonModule } from '@angular/common';
import { KanziPrimeUiModule, MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'kanzi-apes-ui-detail-sidebar',
    imports: [CommonModule, KanziPrimeUiModule, TranslatePipe],
    templateUrl: './kanzi-ui-detail-sidebar.component.html',
    styleUrls: ['./kanzi-ui-detail-sidebar.component.scss']
})
export class KanziUiDetailSidebarComponent
  implements AfterContentInit, OnDestroy
{
  title = input.required<string>();
  description = input<string>();
  showSidebar = input<boolean>(false);
  showSidebarState = false;

  @Output() closeSiderEvent = new EventEmitter<boolean>();
  @ContentChild('rightTopContent') rightTopContent: TemplateRef<any> | null =
    null;
  @ContentChildren(KanziTemplate) templates: QueryList<KanziTemplate> | null =
    null;
  rightTopContentTemplate: TemplateRef<any> | null = null;

  detailSidebarEffect = effect(() => {
    if (this.showSidebar()) {
      this.showSidebarState = true;
    } else {
      this.showSidebarState = false;
    }
  });

  ngAfterContentInit(): void {
    (this.templates as QueryList<KanziTemplate>).forEach((item) => {
      switch (item.getType()) {
        case 'rightTopContent':
          this.rightTopContentTemplate = item.template;
          break;
        default:
          break;
      }
    });
  }

  closeDetailSider() {
    this.closeSiderEvent.emit(true);
  }

  ngOnDestroy(): void {
    this.detailSidebarEffect.destroy();
  }
}
